import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-domiciliar`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        getUnidades(params) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(params)}`)
        },
        getInfraestruturas(params) {
            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(params)}`)
        },
        getEquipes(params) {
            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(params)}`)
        },
        getOcupacoes(params) {
            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(params)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(params) {
            return repository.get(`${baseUrl}/edit?${urlUtil.serialize(params)}`)
        },
        update(params) {
            return repository.put(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        getArea(params) {
            return repository.get(`${baseUrl}/area?${urlUtil.serialize(params)}`)
        }
    }
}